<template>
  <div class="animated fadeIn sales-items">
    <b-card v-show="showList">
      <div slot="header">Sales Item (Posting Group) 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">Medium </span></b-input-group-prepend>
                    <b-form-select
                      v-model="tblData.mediumName"
                      :plain="true"
                      :options="mediumFilt"
                    ></b-form-select>
              <b-input-group-prepend><span class="p-2">Channel </span></b-input-group-prepend>
                    <b-form-select
                      v-model="tblData.channel_name"
                      :plain="true"
                      :options="channelFilt"
                    ></b-form-select>
                  <b-input-group-append>
                    <b-button
                      variant="success"
                      size="sm"
                      @click="search()"
                      class="ml-3"
                    >
                      <i class="fa fa-refresh"></i> Apply Filter</b-button
                    >
                  </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"

        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(saleCrCode)="data">
          {{ data.item.saleCrCode}} | {{ data.item.saleCrName}}
        </template>
        <template v-slot:cell(saleDefrCode)="data">
          {{ data.item.saleDefrCode}} | {{ data.item.saleDefrName}}
        </template>
        <template v-slot:cell(saleFeeCode)="data">
          {{ data.item.saleFeeCode}} | {{ data.item.saleFeeName}}
        </template>
        <!-- <template v-slot:cell(saleDiscCode)="data">
          {{ data.item.saleDiscCode}} | {{ data.item.saleDiscName}}
        </template> -->
        <template v-slot:cell(reimbCode)="data">
          {{ data.item.reimbCode}} | {{ data.item.reimbName}}
        </template>
        <template v-slot:cell(pphDbCode)="data">
          {{ data.item.pphDbCode}} | {{ data.item.pphDbName}}
        </template>
        <!-- <template v-slot:cell(iklancetak)="data">
          <span v-if="data.item.iklancetak==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(iklandigital)="data">
          <span v-if="data.item.iklandigital==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(required_jadwal)="data">
          <span v-if="data.item.required_jadwal==1"><i class="fa fa-check "></i></span>
        </template> -->

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Form - Sales Items (Posting Group) 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col lg="6">
              <b-input-group >
                  <b-input-group-prepend><label>Medium Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.mediumName" :state="!$v.frmdata.mediumName.$error"></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Channel Category</label></b-input-group-prepend>
                    <b-form-select
                      v-model="frmdata.channel_id"
                      :plain="true"
                      :options="channels"
                    ></b-form-select>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Sales/Revenue Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleCrInfo" :state="!$v.frmdata.saleCrCode.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleCr')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Deffered/Unearned Revenue</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleDefrInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleDefr')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Sales Commision/Fee Acc.</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleFeeInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleFee')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>COS Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.reimbInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('reimb')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>PPH Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.pphDbInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('pphDb')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>
<style lang="scss">
  .sales-items {
      .input-group {
          padding-bottom:2px;
          .input-group-prepend {
              label {
                  padding-top: 5px;
                  padding-right: 5px;
                  width: 180px;
              }
          }
      }
  }
</style>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import arSaleAcc from "../../apis/arsalesaccount";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuCoa},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        mediumName: { required },
        saleCrCode: { required },
        reimbCode: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      lkuCoaShow:false,
      lkuCoaCaller:'saleCr',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{mediumName: '',saleFeeCode: '', saleDefrCode: '', saleCrCode: '', saleDiscCode:'' },
      user: this.$store.state.user,
      channels: [{ value: "", text: "" }],channelFilt: [{ value: "", text: "--- ALL ---" }],
      mediums: [],mediumFilt: [{ value: "", text: "--- ALL ---" }],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      items:[],
      filter: null,
    tblFields:[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "mediumName",
            label: "Medium",
            sortable: true
          },
          {
            key: "channel_name",
            label: "Channel",
            sortable: true
          },
          {
            key: "saleCrCode",
            label: "Sales/Revenue Account",
            sortable: true
          },
          {
            key: "saleFeeCode",
            label: "Comission/Fee Account",
            sortable: true
          },
          {
            key: "saleDefrCode",
            label: "Deffered/Unearned Account",
            sortable: true
          },
          {
            key: "reimbCode",
            label: "COS Account",
            sortable: true
          },
          {
            key: "pphDbCode",
            label: "PPH Code",
            sortable: true
          },
        ]

    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
        const [mediums, channels] = await Promise.all([
          crud.list({
            tablename: "medium",
            page: 1,
            limit: 10000,
            total: 0,
            sortBy: "name",
            sortDesc: false,
          }),
          crud.list({
            tablename: "chanel",
            page: 1,
            limit: 10000,
            total: 0,
            sortBy: "name",
            sortDesc: false,
          }),
        ]);
        
        mediums.forEach((tp) => {
          this.mediums.push({ value: tp._id, text: tp.name });
          this.mediumFilt.push({ value: tp.name, text: tp.name });
        });

        channels.forEach((tp) => {
          this.channels.push({ value: tp._id, text: tp.name });
          this.channelFilt.push({ value: tp.name, text: tp.name });
        });

      this.tblFields.push( 
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
      );      
  },

  methods: {
    exportxls: async function() {
        this.isLoading=true;
        try {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            const response = await arSaleAcc.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await arSaleAcc.list(this.tblData);     
      this.items= list; 
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page = 1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.mediumName = "";
      this.tblData.channel_name = "";
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      // this.frmdata.grouplama = data.groupname;
      this.frmdata.kodelama = data.kode;
      this.frmdata.saleDefrInfo = (data.saleDefrCode || '').trim() + ' | ' + (data.saleDefrName || '').trim();
      this.frmdata.saleCrInfo = (data.saleCrCode || '').trim() + ' | ' + (data.saleCrName || '').trim();
      this.frmdata.saleFeeInfo = (data.saleFeeCode || '').trim() + ' | ' + (data.saleFeeName || '').trim();
      this.frmdata.saleDiscInfo = (data.saleDiscCode || '').trim() + ' | ' + (data.saleDiscName || '').trim();
      this.frmdata.reimbInfo = (data.reimbCode || '').trim() + ' | ' + (data.reimbName || '').trim();
      this.frmdata.pphDbInfo = (data.pphDbCode || '').trim() + ' | ' + (data.pphDbName || '').trim();
      
      // this.frmdata.PrePaymDbAccInfo = data.PrePaymDbAcc;
      // let _selected;
      // try {
      //   if (data.ApAccount) {
      //     _selected = await arSaleAcc.findcoa({kodeacc: data.ApAccount, tahun: this.tahun});
      //     this.frmdata.ApAccountInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.ApUnBillCrAcc) {
      //     _selected = await arSaleAcc.findcoa({kodeacc: data.ApUnBillCrAcc, tahun: this.tahun});
      //     this.frmdata.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.PrePaymDbAcc) {
      //     _selected = await arSaleAcc.findcoa({kodeacc: data.PrePaymDbAcc, tahun: this.tahun});
      //     this.frmdata.PrePaymDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      // } catch (error) {
      //   if (error.message) {
      //       toastr.error(error.message);
      //   } else {
      //       toastr.error(JSON.stringify(error));
      //   }                      
      // }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                await arSaleAcc.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      // await arSaleAcc.remove({tablename:'salegroup', key:this.model.kode});

      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}Code`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}Name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({path:"home"});
    },    
  }
};
</script>
